<template>
    <div class="ssoPage">
        <sso-header></sso-header>
        <div class="ssoContent">
            <sso-content>
                <router-view></router-view>
            </sso-content>
        </div>
    </div>
</template>
<script>
    import UIHeader from 'ssoHeader';
    import ssoContent from 'ssoContent';
    import bgIcon from './images/ssobg.png';
    import jq from 'jquery';

    module.exports = Vue.component('sso-home',{
        data:function() {
            return {
                bgIcon: bgIcon
            }
        },
        mounted:function(){
            jq(".ssoPage").css("minHeight", $(window).height());
            jq(".ssoPage").css(
                'background-image','url('+this.bgIcon+')'
            )
            jq(".ssoPage").css(
                'background-size','100%, 100%'
            )
        }
    })
</script>
<style lang="scss" scoped>
    .ssoPage{
        position: relative;
        width: 100%;
        height: 100%;
        .bgImg{
            position: absolute;
            left: 0px;
            right: 0px;
            top: 0px;
            bottom: 0px;
            z-index:-2;
            height: 100%;
            width: 100%;
        }
        .ssoContent{
            margin-top:110px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/sso/view/home/home.vue